import { SxProps } from "@mui/material";
import {
  AllButtonVariants,
  ButtonSize,
  ButtonType,
} from "@/modules/common/components/ui-kit/buttons/shared/types";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import {
  buttonSizes,
  iconButtonSizes,
  variantStyles,
} from "@/modules/common/components/ui-kit/buttons/shared/constants";
import { SemanticIndicatorColors } from "@/styles/nawy-theme/foundation/colors/semantic";
import { colorOptions } from "@/styles/nawy-theme/foundation/colors/semantic";

// Function to determine icon size based on button size
export const getIconSize = (size: ButtonSize = "md"): number => {
  const sizeMap = { sm: 16, md: 18, lg: 20 };
  return sizeMap[size];
};

// Unified base styles function for all button types
export const getBaseStyles = (
  variant: AllButtonVariants,
  size: ButtonSize = "md",
  buttonType: ButtonType = "button"
): SxProps => {
  const baseStyles: SxProps = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: buttonType === "icon-pill" ? "50%" : nawyTheme.nawy.radius.lg,
    gap: nawyTheme.nawy.spacing.xxs,
    textTransform: "none",
    cursor: "pointer",
    whiteSpace: "nowrap",
    ...variantStyles.get(variant),
  };

  if (buttonType === "icon-button" || buttonType === "icon-pill") {
    const iconSizeConfig = iconButtonSizes.get(size);
    return {
      ...baseStyles,
      width: iconSizeConfig,
      height: iconSizeConfig,
      minWidth: iconSizeConfig,
      "& svg": {
        width: `${getIconSize(size)}px`,
        height: `${getIconSize(size)}px`,
      },
    };
  }

  const buttonSizeConfig = buttonSizes.get(size);
  return {
    ...baseStyles,
    ...buttonSizeConfig,
  };
};

export const getRandomColor = (name: string): SemanticIndicatorColors => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    const char = name.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  const index = Math.abs(hash) % colorOptions.length;
  return colorOptions[index];
};
